import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const EmployeeInfo = (t0)=>{
    const $ = c(8);
    const { width, height, color } = t0;
    let t1;
    let t2;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.252 8.5C14.252 10.433 12.6849 12 10.752 12C8.81896 12 7.25195 10.433 7.25195 8.5C7.25195 6.567 8.81896 5 10.752 5C12.6849 5 14.252 6.567 14.252 8.5ZM12.752 8.5C12.752 9.60457 11.8565 10.5 10.752 10.5C9.64738 10.5 8.75195 9.60457 8.75195 8.5C8.75195 7.39543 9.64738 6.5 10.752 6.5C11.8565 6.5 12.752 7.39543 12.752 8.5Z",
            fill: color
        });
        t2 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.99805 6.57996L3.00391 6.57993V7.86001L2.99805 7.85999H2.24805C1.83383 7.85999 1.49805 8.19577 1.49805 8.60999C1.49805 9.0242 1.83383 9.35999 2.24805 9.35999H2.99805L3.00391 9.35996V10.64L2.99805 10.64H2.24805C1.83383 10.64 1.49805 10.9758 1.49805 11.39C1.49805 11.8042 1.83383 12.14 2.24805 12.14H2.99805L3.00391 12.14V13.4201L2.99805 13.42H2.24805C1.83383 13.42 1.49805 13.7558 1.49805 14.17C1.49805 14.5843 1.83383 14.92 2.24805 14.92H2.99805C3.03441 14.92 3.07017 14.9175 3.10515 14.9124C3.505 16.6819 5.04239 18 6.87793 18H14.626C16.7655 18 18.5 16.2091 18.5 14V6C18.5 3.79086 16.7655 2 14.626 2H6.87793C5.04239 2 3.505 3.31807 3.10515 5.08755C3.07017 5.08254 3.03441 5.07996 2.99805 5.07996H2.24805C1.83383 5.07996 1.49805 5.41574 1.49805 5.82996C1.49805 6.24417 1.83383 6.57996 2.24805 6.57996H2.99805ZM4.50391 14C4.50391 14.388 4.58587 14.7499 4.73069 15.0711C6.42879 13.8357 8.50369 13.1076 10.7444 13.1076C12.9901 13.1076 15.0693 13.839 16.7695 15.0794C16.9166 14.7561 17 14.3913 17 14V6C17 4.57368 15.8922 3.5 14.626 3.5H6.87793C5.61168 3.5 4.50391 4.57368 4.50391 6V14ZM10.7444 14.6076C12.6 14.6076 14.3244 15.1927 15.7549 16.1977C15.4149 16.3915 15.0285 16.5 14.626 16.5H6.87793C6.47216 16.5 6.08266 16.3897 5.74067 16.193C7.16984 15.1908 8.89165 14.6076 10.7444 14.6076Z",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== t2 || $[6] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            viewBox: "0 0 20 20",
            width: width,
            height: height,
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = t2;
        $[6] = width;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
export { EmployeeInfo };
